export default function(url: string, w: number, h: number) {
    let width = w || window.innerWidth - 200;
    let height = h || window.innerHeight - 50;
    let settings = navigator.userAgent.indexOf("Chrome") != -1 ? 'scrollbar=yes' : `toolbar=0,status=1,resizable=1,scrollbars=0,menubar=0,location=1`;

    window.open(url, '_blank', `${settings},width=${width},height=${height}`);
}